{
  "mask": {
    "BsoCore": {
      "formGroupTitle": "BSO",
      "bsoEnvironment": "Umfeld",
      "bsoAuth": "Auth-Methode",
      "bsoBasicAuthUsername": "Nutzername",
      "bsoBasicAuthPassword": "Passwort",
      "bsoBearerToken": "Inhaber-Token",
      "bsoTheme": "Theme"
    }
  }
}